export const screenSizes = ["mobile", "tablet", "tablet-large", "laptop", "desktop", "desktop-wide"] as const;

export enum ScreenSizesEnum {
  Mobile = "mobile",
  Tablet = "tablet",
  TabletLarge = "tablet-large",
  Laptop = "laptop",
  Desktop = "desktop",
  DesktopWide = "desktop-wide",
}

export type ScreenSize = (typeof screenSizes)[number];
